<script>
  export let onChange = () => {}
  export let value = false

  function handleKeyUp(e) {
    e.stopPropagation()

    if (e.key === " ") {
      onChange(!isOn)
    }
  }

  function handleToggle(e) {
    e.stopPropagation()
    onChange(!isOn)
  }

  $: isOn = value
</script>

<div
  aria-checked={isOn}
  class="border flex items-center p-[0.3rem] relative rounded-[1rem] shadow-sm w-[3rem] transition"
  class:bg-blue-500={isOn}
  class:bg-slate-200={!isOn}
  class:border-blue-600={isOn}
  class:border-slate-400={!isOn}
  on:click={handleToggle}
  on:keyup={handleKeyUp}
  role="switch"
  tabindex={0}
>
  <button
    class="bg-white border border-slate-400 h-[1rem] relative rounded-[50%] shadow-md w-[1rem] transition-transform"
    class:translate-x-[1.4rem]={isOn}
    type="button"
  />
</div>
